import * as types from './types'
import Cookies from 'js-cookie'

const id = Cookies.get('vendor_id')

const state = {
  fetched: true,
  title: null,
  type: null,
  name: null,
  id,
  logo: null,
  show_attr_list: 1,
}

const mutations = {
  [types.FETCHED]: (state) => {
    state.fetched = false
  },
  [types.SET]: (state, { title, type, name, id, logo, show_attr_list }) => {
    Object.assign(state, {
      title,
      type,
      name,
      id,
      logo,
      show_attr_list,
    })
    Cookies.set('vendor_id', id)
  },
}

export default {
  namespace: true,
  state,
  mutations,
}
